import { render } from "./GptHome.vue?vue&type=template&id=0605065c&scoped=true"
import script from "./GptHome.vue?vue&type=script&lang=js"
export * from "./GptHome.vue?vue&type=script&lang=js"

import "./GptHome.vue?vue&type=style&index=0&id=0605065c&lang=less&scoped=true"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0605065c"]])

export default __exports__